import 'components/BgSection/index.scss';
import ResearchCut from 'components/ResearchCut';
import React, {FC, useState} from 'react';
import {flatBem} from 'utils/bem';
import {Configurator} from 'utils/makeConfigurator';

const b = flatBem('BgSection');

type Props = {
  conf?: Configurator;
  allCutBlock?: {
    title?: React.ReactNode;
    initialState?: boolean;
  };
  avatarBlock?: {
    imgUrl?: string;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
  };
  mainBlock?: {
    title?: React.ReactNode;
    content?: React.ReactNode;
  };
  bottomCutBlock?: {
    title?: React.ReactNode;
    content?: React.ReactNode;
    initialState?: boolean;
  };
};

const Index: FC<Props> = ({allCutBlock, avatarBlock, mainBlock, bottomCutBlock}) => {
  const [allCutOpen, setAllCutOpen] = useState(allCutBlock?.initialState ?? true);
  const [bottomCutOpen, setBottomCutOpen] = useState(bottomCutBlock?.initialState ?? false);
  return (
    <div className={b()}>
      {allCutBlock && (
        <ResearchCut header={allCutBlock.title} state={allCutOpen} onStateChange={setAllCutOpen} />
      )}
      {allCutOpen && (
        <div className={b('allBlock')} style={allCutBlock && {padding: '20px 40px'}}>
          {avatarBlock && (
            <div className={b('avatarBlock')}>
              {avatarBlock.imgUrl && (
                <img src={avatarBlock.imgUrl} className={b('avatarBlock-img')} alt="" />
              )}
              <div className={b('avatarBlock-titleBlock')}>
                {avatarBlock.title && (
                  <div className={b('avatarBlock-title')}>{avatarBlock.title}</div>
                )}
                {avatarBlock.subtitle && (
                  <div className={b('avatarBlock-subtitle')}>{avatarBlock.subtitle}</div>
                )}
              </div>
            </div>
          )}
          {mainBlock && (
            <div className={b('mainBlock', avatarBlock ? [] : ['no-avatar-block'])}>
              {mainBlock.title && <div className={b('mainBlock-title')}>{mainBlock.title}</div>}
              {mainBlock.content && (
                <div className={b('mainBlock-content')}>{mainBlock.content}</div>
              )}
            </div>
          )}
          {bottomCutBlock && (
            <>
              <ResearchCut
                header={bottomCutBlock.title}
                state={bottomCutOpen}
                onStateChange={setBottomCutOpen}
              />
              {bottomCutOpen && (
                <div className={b('bottomCutBlock-content')}>{bottomCutBlock.content}</div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Index;
